export const environment = {
  production: false,
  base_url: 'http://alltel-api.matthew.com/api',
  my_alltel_url: 'https://my.allteltest.com'
};
